import { i18n } from '@lingui/core'
import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'

import Flag from 'views/components/atoms/Flag'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'
import { VOLUME_PRICING_MODAL_ID } from 'views/components/organisms/VolumePricingModal/names'
import { OPEN_VOLUME_PRICING_MODAL } from 'views/containers/browser/VolumePricingModalContainer/clientsideHook'

import { useGenerateVolumePricingBadgeData } from './useGenerateVolumePricingBadgeData'

const VolumePricingBadge = ({
  upid,
  selectedQuantity,
  volumePricing,
  sellerId,
}: {
  upid: string
  selectedQuantity: number
  volumePricing: VolumeBasedPriceV1[]
  sellerId: string
}) => {
  const { discount, discountActivated, quantity } =
    useGenerateVolumePricingBadgeData(selectedQuantity, volumePricing)

  return (
    <div
      className="u-display--inline-block u-margin-x-small--bottom u-margin-x-small--top o-ProductInfo__labels"
      data-clientside-hook={OPEN_VOLUME_PRICING_MODAL}
      tabIndex={0}
      data-a11y-dialog-show={VOLUME_PRICING_MODAL_ID}
      data-product-identifier={upid}
      data-seller-identifier={sellerId}
      role="button"
    >
      <Flag
        withIcon
        label={
          discountActivated
            ? i18n._('volumePricing.pdp.label.maxDiscount.text', { discount })
            : i18n._('volumePricing.pdp.label.text', { discount, quantity })
        }
      >
        <div className="u-padding-x-small--left l-flex">
          <IconCircleInfoOutline size="x-small" />
        </div>
      </Flag>
    </div>
  )
}

export default VolumePricingBadge
